import TTabs from './tabs.vue'
import TTabPanel from './panel.vue'
TTabs.Panel = TTabPanel

export default TTabs



// WEBPACK FOOTER //
// ./src/components/tabs/index.js